var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"className":"animated"}},[_c('b-card',{staticClass:"currency-control",staticStyle:{"padding":"unset"}},[_c('b-card-header',[_vm._v(" Currency Control ")]),_c('b-card-body',{staticClass:"p-4"},[_c('currency-control-table')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }